<template>
  <div>
    <!-- this.showForgetPwdPop=false;-->
    <div  class="login-wrapper">
      <!--账号登录-->
      <div class="login-container" @keydown.enter="enterKeydown">
        <div class="login-container-left">
          <img src="../../assets/images/login/bround.png" alt="">
        </div>
        <div class="login-container-right">
          <!-- 关闭页面按钮-->
          <span class="iconfont icon-guanbi Shut" style="color: #666666" @click="closeClick"></span>
          <!--账号登录页面-->
          <div class="login-content"  v-show="isShow">
            <h2 class="container-right_title">账号登录</h2>
            <Form class="login-form" ref="formInline" :model="loginForm" :rules="loginFormRules" inline>
              <FormItem prop="number" class="form-item">
                <div class="icon-phone">
                  <div class="iconfont icon-shouji icon-phone_child"></div>
                </div>
                <Input class="login-input" placeholder="请输入手机号"  v-model.trim="loginForm.number"></Input>
                <span class="iconfont icon-guanbi on" style="color: #999999" @click="clickIcon"></span>
              </FormItem>
              <FormItem prop="password" class="form-item">
                <div class="icon-phone">
                  <div class="iconfont icon-lock icon-phone_child"></div>
                </div>
                <Input class="login-input" :type="pwdType" placeholder="请输入密码" v-model.trim="loginForm.password" ></Input>
                <span :class="eyes? icon1 : icon2" @click="yanjing" style="color: #999999"></span>
              </FormItem>
              <div class="login-text">
                <Checkbox v-model="single">记住密码</Checkbox>
                <ul class="login-pass">
                  <li @click="forgetPwd">修改密码</li>
                  <li @click="goRegister">免费注册</li>
                </ul>
              </div>
              <!--登录按钮-->
              <FormItem class="login-button">
                <button class="button-public button-one" @click.prevent="login">立即登录</button>
                <button class="button-public button-tow" @click.prevent="textLogin">短信登录</button>
              </FormItem>
            </Form>
          </div>

          <!--短信登录页面-->
          <div class="login-content" v-show="isMessageShow">
            <h2 class="container-right_title">短信登录</h2>
            <Form class="login-form" :model="loginForm" :rules="loginFormRules1" ref="loginFormRef1">
              <FormItem prop="number" class="form-item">
                <div class="icon-phone">
                  <div class="iconfont icon-shouji icon-phone_child"></div>
                </div>
                <Input class="login-input" placeholder="请输入手机号" v-model="loginForm.number"></Input>
                <span class="iconfont icon-guanbi on" style="color: #999999" @click="clickIcon"></span>
              </FormItem>
            </Form>
            <div class="login-text">
              <span>没有账号？</span>
              <span class="register" style="color: #fd6621" @click="goRegister">前往注册账号</span>
            </div>
            <!--登录按钮-->
            <div class="login-button1">
              <button class="button-public button-one button-code" @click="getNumb">获取动态码</button>
              <button class="button-public button-tow button-code code2 " @click="goLogin">账号登录</button>
            </div>
          </div>

          <!--短信获取验证码-->
          <div class="login-content" v-show="isCodeShow">
            <h2 class="container-right_title">短信登录</h2>
            <div class="login_sent">
              <div class="smsCode">短信验证码已发送至</div>
              <span style="color: #fd6621">{{number}}</span>
            </div>
            <Form class="login-form" :model="loginForm" ref="loginFormRef">
              <FormItem prop="number" class="form-item">
                <div class="icon-phone">
                  <div class="iconfont icon-email icon-phone_child"></div>
                </div>
                <Input class="login-input" placeholder="短信验证码" v-model="code"></Input>
                <span class="login-time" v-if="count > 0">{{count}}秒后重新获取</span>
                <span class="login-time" v-else @click="getTimeNum">重新获取</span>
              </FormItem>
            </Form>
            <!--登录按钮-->
            <div class="login-button1" style="margin-top: 0">
              <button class="button-public button-one button-code" @click="submitCode">立即登录</button>
              <button class="button-public button-tow button-code code2" @click="goLogin">账号登录</button>
            </div>
          </div>

          <div class="login-content" v-show="isQrCodeShow">
            <h2 class="container-right_title">微信登录</h2>
            <div class="line"></div>
            <div>
              <img style="width: 185px;height: 185px;" v-bind:src="qrCode" alt="">
            </div>
          </div>

          <!--  快捷登录方式-->
          <div class="login-other">
            <div class="other">
              <div class="line"></div>
              <span>快捷登录方式</span>
              <div class="line"></div>
            </div>
            <div class="bottom_img">
              <ul class="icon-yuan">
                <li class="iconfont icon-qq1 icon-login" @click="qqLogin"></li>
              </ul>
              <ul class="icon-yuan" v-on:click="wxLogin">
                <li class="iconfont icon-weixin2 icon-login"></li>
              </ul>
            </div>
            <!-- <div class="login_xieyi">
              <label>
                <input type="checkbox" class="tongyi">我已阅读并同意<a v-on:click="showUserAgreement">《用户服务协议》</a>
              </label>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import bus from "@/util/bus"

  export default {
    name: "toLogin", //账号登录
    data() {
        return {
          single:false,
          seen:'',
          eyes: "iconfont icon-yanjing on",
          icon2: "iconfont icon-yanjing1 on",
          icon1: "iconfont icon-yanjing on",
          pwdType: 'password',
          showForgetPwdPop: false,
          count: 60, //倒计时提示的文字
          timer: null,
          isShow:true,
          isCodeShow:false,
          isMessageShow:false,
          isQrCodeShow:false,
          qrCode:'',
          number:null,  //手机号
          code:'', // 短信验证码
          checkCode:'',
          //登录的数据绑定
          loginForm: {
            number: '',
            password: ''
          },
          //表单验证规则
          loginFormRules: {
            number: [
              {required: true, message: '请输入手机号码', trigger: 'blur'},
              {pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur"}
            ],
            password: [
              {required: true, message: '请输入密码', trigger: 'blur'},
              {min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur'}
            ]
          },
          loginFormRules1: {
            number: [
              {required: true, message: '请输入手机号码', trigger: 'blur'},
              {pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur"}
            ]
          }

        }
    },
    methods: {
      enterKeydown() {
        if (this.isShow) {
          this.login()
        } else if (this.isCodeShow) {
          this.submitCode()
        }
      },
      //控制眼睛图标的切换
      yanjing() {
        this.pwdType = this.pwdType === 'password' ? 'text' : 'password';
        this.eyes = !this.eyes;
      },
      clickIcon() {
        this.loginForm.number = ''
      },
      //账号登录
      login() {
        this.$refs['formInline'].validate((valid) => {
          if (valid) {
            this.$Axios.post('userInfo/login',{
              logonUser: this.loginForm.number,
              pwd: this.loginForm.password
            }).then(res=>{
                if (res.success !== true){
                  this.$Message.error(res.errors[0].message);
                } else {
                  if (res.data.state !== 'A') {
                    this.$Message.error("帐号状态不可用，请联系管理员");
                    return;
                  }
                  if (this.single == true){
                    this.$cookies.set("username",this.loginForm.number);
                    this.$cookies.set("password",this.loginForm.password);
                  } else {
                    this.$cookies.remove("username");
                    this.$cookies.remove("password");
                  }
                  this.$cookies.set("single", this.single);
                  //更换为Vuex
                  // window.sessionStorage.setItem("userinfo", JSON.stringify(res.data));
                  this.$store.dispatch("sessions/setUserinfo",res.data);
                  this.$router.push("/",res.data)
                  bus.$emit("showLogin",4);
                  bus.$emit("jumpToDetail",1);
                // window.location.reload()
                // this.showForgetPwdPop = false;
                }
              }).catch(err=>{
                this.$Message.error(err);
              })
          } else {
            this.$Message.error('登录失败，请重试!');
            /*this.$Message.error({
              content: '登录失败，请重试!',
              duration: 1000
            })*/
          }
        })
      },
      //进入短信登录
      textLogin() {
        this.isMessageShow = true;
        this.isShow = false
      },
      //进入账号登录页面
      goLogin() {
        this.isMessageShow = false;
        this.isCodeShow = false;
        this.isShow = true;
      },
      //进入账号登录
      toLogin() {
        this.isMessageShow = !this.isMessageShow;
        this.isCodeShow = !this.isCodeShow;
      },
      
      qqLogin() {
        let ticket;
        this.$Axios.post('oauth/getToken').then(res => {
          if (res.success) {
            ticket = res.data;
            if(ticket){
              this.$Axios.post("oauth/pc/qqLogin", {ticket: ticket}, false).then(res => {
                if(res.success){
                  this.openQQQrCodeWindow(res, ticket);
                }
              })
            }
          }
        });
      },

      //打开QQ二维码窗口
      openQQQrCodeWindow(res, ticket) {
        if(!res || !ticket){
          this.$Message.error("要求传入后台响应数据及ticket!");
          return;
        }
        let A=window.open(res.data,"_blank");
        this.count = 12;
        this.timer = setInterval(() => {
          if (this.count <= 0) {
            clearInterval(this.timer)
            this.timer = null
          } else {
            this.$Axios.post('oauth/getToken', {ticket: ticket}, false).then(res => {
              if (res.success) {
                this.$store.dispatch("sessions/setUserinfo", res.data);
                window.location.reload();
                A.close();
              }
            });
            this.count--;
          }
        }, 5000)
      },

      wxLogin() {
        this.isQrCodeShow = true
        this.isShow = false
        this.isMessageShow = false
        this.$Axios.post('wxevent/getQrCode').then(res => {
          if (res.success) {
            let ticket = res.data.ticket
            this.qrCode = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + ticket
            this.count = 12
            this.timer = setInterval(() => {
              if (this.count <= 0) {
                clearInterval(this.timer)
                this.timer = null
              } else {
                this.getToken(ticket)
                this.count--
              }
            }, 5000)
          }
        })
      },

      // 往后台轮询获取token
      getToken(ticket) {
        console.log(this.count, "count")
        this.$Axios.post('wxevent/getToken', {ticket: ticket}, false).then(res => {
          if (res.success) {
            this.$store.dispatch("sessions/setUserinfo", res.data);
            window.location.reload();
          }
        })
      },

      info1 (nodesc) {
        this.$Notice.info({
          title: '提示',
          desc: nodesc ? '' : '验证码有效期为2分钟，过期需要重新获取. '
        });
      },

      //进入获取验证码页面
      getNumb() {
        this.$refs['loginFormRef1'].validate(valid => {
          if (valid) {
            //验证码时间提示
            this.info1(false)
            //赋值
            this.isMessageShow = !this.isMessageShow;
            this.isCodeShow = !this.isCodeShow;
            //传值
            bus.$emit('getNumb',this.loginForm.number);
            this.getTimeNum();
          }
        });
      },

      //发送验证码短信并倒计时
      getTimeNum() {
        this.$Axios.post('openApis/sendSMS', {
          mobileNo: this.number,
          // loginCheck: true
          isLoginCheck:true
        }).then(res => {
          console.log(res);
          if (res.success) {
            this.checkCode = res.data;
          } else {
            this.$Message.error(res.errors[0].message);
          }
        });

        //倒计时
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }
      },

      //提交动态码
      submitCode() {
        let query = {
          logonUser: this.number,
          checkCode: this.code
        };
        this.$Axios.post('userInfo/codeLogin', query).then(res => {
          console.log(res);
          if (res.success !== true) {
            this.$Message.error(res.errors[0].message);
            return;
          }
          if (res.data.state !== 'A') {
            this.$Message.error("帐号状态不可用，请联系管理员");
            return;
          }
          //更换为Vuex
          // window.sessionStorage.setItem("userinfo", JSON.stringify(res.data));
          this.$store.dispatch("sessions/setUserinfo",res.data);
          window.location.reload();
        }).catch(res => {
          this.$Message.error(res.message);
        })
      },
      //获取cookie中的账号密码
      getCookie(){
        let number = this.$cookies.get("username");
        let password = this.$cookies.get("password");
        let single = this.$cookies.get("single");
        this.loginForm.number = number;
        this.loginForm.password = password;
        this.single = single === 'true'
      },
      //前往注册
      goRegister() {
        bus.$emit('showLogin',2);
      },
      //前往找回密码
      forgetPwd() {
        bus.$emit('showLogin',3);
      },
      //关闭页面
      closeClick() {
        bus.$emit("showLogin",4);
        /* this.showForgetPwdPop=false;
          window.location.reload();*/
      },

      showUserAgreement() {
        let siteInfo = this.$store.getters["sessions/getSiteInfo"]
        window.open(siteInfo.userAgreement)
      }
    },
    mounted() {
      // 监听传值
      bus.$on('getNumb',(res)=>{
        // console.log(res);
        this.number = res
      });
      this.getCookie()
    },
  }
</script>

<style lang="less" scoped>
  /deep/.ivu-input {
    background-color: #f2f2f2;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/toLogin.vue